import React, { useRef, useState } from "react";
import MainLayout from "../components/MainLayout";
import { foodsAndBeveragesHeader } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import { useEffect } from "react";
import { BindPostAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import FoodAndBeveragespopup from "../popup-containers/FoodAndBeveragespopup";
import MainPopup from "../popup-containers/MainPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import FileUpload from "../ReusableComponents/FileUpload";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const FoodsAndBeverages = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [typeBindDD, settypeBindDD] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [MstFoodAndBeveragesId, setMstFoodAndBeveragesId] = useState("");
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  var createdBy = sessionStorage.getItem("createdBy");
  var clientId = sessionStorage.getItem("MstClientId");
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [selectedFile, setselectedFile] = useState([]);
  const [imageDisabled, setImageDisabled] = useState(false);
  const [fileDisabled, setFileDisabled] = useState(false);
  const [foodTypeBindDD, setFoodTypeBindDD] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const [foodsAndBeverages, setFoodsAndBeverages] = useState([]);

  const [partnerFields, setPartnerFields] = useState({
    mstFoodTypeId: "",
    mstSubFoodTypeId: "",
    foodName: "",
    rate: "",
    Photo: "",
  });

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
  };
  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
    setpopUpOpen(false);
    BindFoodAndBeveragesData();
    setIsLoading(false);
    setPartnerFields({
      mstFoodTypeId: "",
      mstSubFoodTypeId: "",
      foodName: "",
      rate: "",
      Photo: "",
    });
    setPartnerFieldsError({
      typeError: "",
      foodTypeError: "",
      foodNameError: "",
      rateError: "",
      Photo: "",
    });
  };

  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE_MB = 2;
  const ALLOWED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];

  const isFileFormatAllowed = (file) => ALLOWED_FORMATS.includes(file.type);

  const isFileSizeBelowLimit = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  const handleFileChange = (event) => {
    setImageDisabled(false);
    setFileDisabled(true);

    const file = event.target.files[0];
    if (!file) return;

    if (!isFileFormatAllowed(file)) {
      toast.error(`Unsupported file format: ${file.name}`);
      return;
    }

    if (!isFileSizeBelowLimit(file)) {
      toast.error(`File size exceeds the limit`);
      return;
    }

    if (
      selectedFile.length > 0 &&
      selectedFile[0].file.name === file.name &&
      selectedFile[0].file.size === file.size
    ) {
      toast.error("This file is already selected");
      return;
    }

    setselectedFile([
      {
        file,
        previewUrl: URL.createObjectURL(file),
      },
    ]);
  };

  useEffect(() => {
    BindFoodAndBeveragesData();
  }, []);

  const BindFoodAndBeveragesData = async () => {
    setIsLoading(true);
    const data = {
      mstClientId: clientId,
    };
    const response = await BindPostAPI(
      data,
      "FoodAndBeveragesAPI/BindFoodAndBeverages"
    );

    if (response && response.data) {
      setFoodsAndBeverages(response.data.Table);

      const Foodtypes = response.data.Table1.map((item) => ({
        label: item.FoodType,
        value: item.MstFoodTypeId,
      }));
      const FoodSubtypes = response.data.Table2.map((item) => ({
        label: item.SubFoodType,
        value: item.MstSubFoodTypeId,
      }));

      settypeBindDD(Foodtypes);
      setFoodTypeBindDD(FoodSubtypes);
      // setMstFoodAndBevaragesId(foodsAndBeverages[rowIndex].MstFoodAndBeveragesId)
    } else {
      setFoodsAndBeverages([]);
      settypeBindDD([]);
      setFoodTypeBindDD([]);
    }
    setIsLoading(false);
  };

  const handleShowImage = (showImage) => {
    // Set showImage to an empty string if showImage is falsy
    setPartnerFields({
      ...partnerFields,
      Photo: showImage || "", // This will set to showImage if it's truthy, else ""
    });

    // console.log(supplierFields);

    // Reset any error related to showImage
    setPartnerFieldsError({ ...partnerFieldsError, photoError: "" });
  };

  const validate = (flag) => {
    const errors = {};

    if (flag == 1 || flag == 2) {
      if (!partnerFields.mstFoodTypeId) {
        errors.mstFoodTypeId = `Select Veg or non-Veg`;
      }

      if (!partnerFields.mstSubFoodTypeId) {
        errors.mstSubFoodTypeId = `Select Food Type`;
      }

      if (!partnerFields.foodName || !partnerFields.foodName.trim()) {
        errors.foodName = "Enter Food Name";
      }

      if (
        !partnerFields.rate ||
        isNaN(partnerFields.rate) ||
        partnerFields.rate <= 0
      ) {
        errors.rate = "Enter Rate";
      }
    }

    setPartnerFieldsError({
      typeError: errors.mstFoodTypeId || "",
      foodTypeError: errors.mstSubFoodTypeId || "",
      foodNameError: errors.foodName || "",
      rateError: errors.rate || "",
      photoError: errors.photo || "",
    });

    return errors;
  };

  const handleSubmit = async (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const validationErrors = validate(flag);

    if (Object.keys(validationErrors).length !== 0) {
      setIsOpen(true);
      setIsLoading(false);
      setSubmitBtnDisabled(false);
      return;
    }

    setIsOpen(false);

    if (flag == 1 || flag == 2) {
      const data = {
        mstFoodAndBeveragesId: MstFoodAndBeveragesId
          ? MstFoodAndBeveragesId
          : 0,

        foodName: partnerFields.foodName || "",
        mstFoodTypeId: partnerFields.mstFoodTypeId || "",
        mstSubFoodTypeId: partnerFields.mstSubFoodTypeId || "",
        mstClientId: parseInt(clientId, 10) || 0,
        rate: parseInt(partnerFields.rate, 10) || 0,
        fileUpload: partnerFields.Photo || "",
        createdBy: parseInt(createdBy, 10),
        flag: flag,
      };

      const response = await IUDAPI(
        data,
        "FoodAndBeveragesAPI/IUDFoodAndBeverages"
      );
      console.log(response, "response data");
      if (flag == 1) {
        //if flag ==1 , add
        if (response.data.Table[0].Result === "S") {
          toast.success("Food And Bevarages Added Successfully", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Food And Bevarages insert Failed", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 2) {
        //if flag ==2 , update

        if (response.data.Table[0].Result === "M") {
          toast.success("Food And Bevarages  modified successfully! 👍", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Food And Bevarages  modification failed 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    } else if (flag == 3) {
      const data = {
        // data to be send to api, if add/update

        // txnConsumptionId: bindConsumptionData[rowIndex].TxnConsumptionId,
        mstFoodAndBeveragesId:
          foodsAndBeverages[rowIndex].MstFoodAndBeveragesId || 0,

        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(
        data,
        "FoodAndBeveragesAPI/IUDFoodAndBeverages"
      );

      if (flag == 3) {
        //if flag ==3 , delete
        if (response.data.Table[0].Result === "D") {
          toast.success("Consumption Data Deleted Successfully", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to delete Consumption Data ", {
            duration: 2000,
            position: "top-center",
          });
        }
        setTimeout(cancel, 2000);
      }
    } else if (flag == 4) {
      const data = {
        mstFoodAndBeveragesId:
          foodsAndBeverages[rowIndex].MstFoodAndBeveragesId || 0,

        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(
        data,
        "FoodAndBeveragesAPI/IUDFoodAndBeverages"
      );

      if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(" InActivated Successfully", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to  InActivate Data ", {
            duration: 2000,
            position: "top-center",
          });
        }
        setTimeout(cancel, 2000);
      }
    } else if (flag == 5) {
      const data = {
        mstFoodAndBeveragesId:
          foodsAndBeverages[rowIndex].MstFoodAndBeveragesId || 0,

        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(
        data,
        "FoodAndBeveragesAPI/IUDFoodAndBeverages"
      );

      if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(" Activated Successfully", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to  Activate Data ", {
            duration: 2000,
            position: "top-center",
          });
        }
        setTimeout(cancel, 2000);
      }
    }
  };

  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setMstFoodAndBeveragesId(foodsAndBeverages[rowIndex].MstFoodAndBeveragesId);

    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    //setMstFoodAndBevaragesId(foodsAndBeverages[rowIndex].MstFoodAndBevaragesId);

    setPartnerFields({
      ...partnerFields,

      mstFoodTypeId: foodsAndBeverages[rowIndex].MstFoodTypeId,
      mstSubFoodTypeId: foodsAndBeverages[rowIndex].MstSubFoodTypeId,
      foodName: foodsAndBeverages[rowIndex].FoodName,
      rate: foodsAndBeverages[rowIndex].Rate,
      Photo: foodsAndBeverages[rowIndex].FoodImage,
    });
  };

  const [foodAndBeveragesData, setFoodAndBeveragesData] = useState([]);

  const [partnerFieldsError, setPartnerFieldsError] = useState({
    typeError: "",
    foodTypeError: "",
    foodNameError: "",
    rateError: "",
    photo: "",
  });
  const handleFoodandBeverages = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);
    setMstFoodAndBeveragesId(foodsAndBeverages[rowIndex].MstFoodAndBeveragesId);
    setFoodAndBeveragesData(foodsAndBeverages[rowIndex]);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
  };
  console.log(partnerFields, "partnerFields");
  const handleBlur = (field) => {
    setPartnerFieldsError((prev) => {
      const errors = { ...prev };

      switch (field) {
        case "mstFoodTypeId":
          errors.typeError = partnerFields.mstFoodTypeId
            ? ""
            : "Select Veg or Non-Veg";
          break;

        case "mstSubFoodTypeId":
          errors.foodTypeError = partnerFields.mstSubFoodTypeId
            ? ""
            : "Select Food Type";
          break;

        case "foodName":
          errors.foodNameError = partnerFields.foodName?.trim()
            ? ""
            : "Enter Food Name";
          break;

        case "rate":
          errors.rateError =
            partnerFields.rate && !isNaN(partnerFields.rate)
              ? ""
              : "Enter Rate";
          break;

        default:
          break;
      }

      return errors;
    });
  };

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Foods And Beverages"
          header={foodsAndBeveragesHeader}
          records={foodsAndBeverages}
          // blockView={true}
          handleEdit={handleEdit}
          handleAction={handleFoodandBeverages}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div>
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Foods And Beverages"
              />
            </div>
          </div>
          <div class=" flex flex-col w-full">
            <div class={mainTable.clientMasterMainAdd}>
              <div class={mainTable.addShadowScreen}>
                <div class={mainTable.mainContentScreen}>
                  <form class={mainTable.formForClientMaster}>
                    <div class={mainTable.grid4}>
                      <AutoDropDown
                        title="Veg or non-Veg"
                        options={typeBindDD}
                        Class="custom-class"
                        classStar="text-red-500"
                        placeholder="Select"
                        name="mstFoodTypeId"
                        selectedOption={
                          typeBindDD.find(
                            (x) => x.value == partnerFields.mstFoodTypeId
                          ) || null
                        }
                        controlFunc={(option) =>
                          setPartnerFields((prev) => ({
                            ...prev,
                            mstFoodTypeId: option?.value ?? null,
                          }))
                        }
                        controlFuncBlur={() => handleBlur("mstFoodTypeId")}
                        errorMessage={partnerFieldsError.typeError}
                      />

                      <AutoDropDown
                        title="Food Type"
                        options={foodTypeBindDD}
                        Class="custom-class"
                        classStar="text-red-500"
                        placeholder="Select"
                        name="mstSubFoodTypeId"
                        selectedOption={foodTypeBindDD.find(
                          (x) => x.value == partnerFields.mstSubFoodTypeId
                        )}
                        controlFunc={(option) =>
                          setPartnerFields((prev) => ({
                            ...prev,
                            mstSubFoodTypeId: option?.value ?? null,
                          }))
                        }
                        controlFuncBlur={() => handleBlur("mstSubFoodTypeId")}
                        errorMessage={partnerFieldsError.foodTypeError}
                      />
                      <InputText
                        inputType="text"
                        title="Food Name"
                        classStar="text-red-500"
                        name="foodName"
                        content={partnerFields.foodName}
                        controlFunc={(e) =>
                          setPartnerFields((prev) => ({
                            ...prev,
                            foodName: e.target.value,
                          }))
                        }
                        controlFuncBlur={() => handleBlur("foodName")}
                        errorMessage={partnerFieldsError.foodNameError}
                      />
                      <InputText
                        inputType="text"
                        title="Rate"
                        classStar="text-red-500"
                        name="rate"
                        content={partnerFields.rate}
                        controlFunc={(e) =>
                          setPartnerFields((prev) => ({
                            ...prev,
                            rate: e.target.value,
                          }))
                        }
                        controlFuncBlur={() => handleBlur("rate")}
                        errorMessage={partnerFieldsError.rateError}
                      />

                      <div></div>
                    </div>
                    <FileUpload
                      title="Photo"
                      apiCall="FoodAndBeveragesAPI/FoodAndBeveragesImageUpload"
                      modalName="FoodAndBeveragesImages"
                      name="showImage"
                      disabledBtn={updateScreenTitle}
                      showImage={partnerFields.Photo}
                      showImageData={handleShowImage}
                      imageUploadedError={partnerFieldsError.photoError}
                      limitMassage="Image size limit: 2MB. Accepted Image types: jpg, png, jpeg."
                      MAX_FILE_SIZE_MB={2}
                      ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center gap-4">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              disabledBtn={false}
              viewSaveButton={false}
              handleSubmit={handleSubmit}
              cancel={cancel}
            />
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleFoodandBeverages}
      >
        <div>
          <PopUpScreenTitle
            title="FoodandBeverages"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <FoodAndBeveragespopup data={foodAndBeveragesData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
          rowIndex={rowIndex}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default FoodsAndBeverages;
